import routerOptions0 from "/usr/src/app/app/router.options.js";
import routerOptions1 from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}